import React from 'react';
import ReactDOM from 'react-dom/client';
import * as ReactDOMFull from 'react-dom';
import './index.css';
import App from './App.jsx';

// ── Design System bundle (Yool*) ─────────────────────────────────────────────
// public/ds/_ds_bundle.js es un IIFE que expone window.DesignSystemRemix_1a4bd3
// y usa window.React como shim (misma versión 18.3.1). Exponemos el React de
// tadmin ANTES de cargarlo y montamos la app cuando el bundle terminó (o falló),
// para que FormKit componga los componentes Yool* reales del design system.
if (typeof window !== 'undefined') {
  window.React = React;
  window.ReactDOM = ReactDOMFull;
}

function mountApp() {
  const root = ReactDOM.createRoot(document.getElementById('root'));
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
}

(function loadDesignSystem() {
  if (typeof document === 'undefined' || window.DesignSystemRemix_1a4bd3) {
    mountApp();
    return;
  }
  const s = document.createElement('script');
  s.src = (process.env.PUBLIC_URL || '') + '/ds/_ds_bundle.js';
  s.async = false;
  s.onload = mountApp;
  s.onerror = () => {
    console.error('[DS] No se pudo cargar _ds_bundle.js — FormKit usará sus fallbacks.');
    mountApp();
  };
  document.head.appendChild(s);
})();
